import React from 'react';
import { Route } from 'react-router-dom';
import TodoPage from 'modules/todo/pages/TodoPage';
import todoReducer from 'modules/todo/features/todoSlice';

/**
 * Modul-Definition "Aufgaben" (todo).
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js).
 */
const todoModul = {
  id: 'todo',
  name: 'Aufgaben',
  description:
    'Persönliche TODO-Liste mit Kategorien, Prioritäten, Fälligkeitsdaten und wiederverwendbaren Vorlagen.',
  path: '/projekte/todo',
  icon: '✅',
  gradient: 'from-violet-400 to-fuchsia-600',
  status: 'active',
  reducers: {
    todo: todoReducer,
  },
  routes: <Route path="/projekte/todo" element={<TodoPage />} />,
};

export default todoModul;
